<div class="doughnut-chart">
    <highcharts-chart
        [options]="chartOptions()"
        [style.width.px]="doughnutWidth()"
        [style.height.px]="doughnutHeight()"
        style="display: block"
        [(update)]="updateFlag"
    ></highcharts-chart>
</div>
@if (legendData()?.length) {
    <div class="legend-container">
        <div class="legend-grid">
            @for (legend of legendData(); track $index) {
                <div class="legend">
                    <span
                        [style.backgroundColor]="datasetColors()[$index]"
                    ></span>
                    <p>{{ legend }}</p>
                </div>
            }
        </div>
    </div>
}
